
export class Pacient {
  id?: string;
  cns?: string;
  cpf?: string;
  ativo?: boolean;
  dtNascimento?: string;
  deceasedDateTime?: string;
  genero?: string;
  nome?: string;
  nomeUnsual?: string;
  endereco?: string;
  uf?: string;
  municipio?: string;
  pais?: string;
  consentimento?: string;
  prazo?: string;
  telefoneTrabalho?: string;
  telefone?: string;
  foto?: string;
  email?: string;
  idade?: string;
  nomeSocial?: string;

  constructor(data?) {
    if (data) {
      console.log('data', data);
      this.id = data.id;
      this.cns = data.id;
      this.ativo = data.active;
      this.dtNascimento = data.birthDate;
      this.deceasedDateTime = data.deceasedDateTime;
      this.genero = data.gender;
      this.nomeSocial = data.nomeSocial;

      //===== Consentimento
      this.consentimento = 'Concedido';
      this.prazo = '20/05/2019 - 09:45';
      this.idade = this.calcAge(data.birthDate);

      if (data.identifier) {
        data.identifier.forEach(e => {
          if (e && e.system && e.system.indexOf('/cpf') >= 0) {
            this.cpf = e.value;
          }
        });
      }

      if (data.name) {
        for (const item of data.name) {
          if (item.use === 'official') {
            this.nome = item.text;
          }
          if (item.use === 'usual') {
            this.nomeUnsual = item.text;
          }
        }
      }
      if (data.address) {
        for (const item of data.address) {
          if (item.use === 'home') {
            if (item.line) {
              this.endereco = item.line.join(', ');
            }
            if (item.city) {
              this.municipio = item.city;
            }
            if (item.state) {
              this.uf = item.state;
            }
            if (item.country) {
              this.pais = item.country;
            }
          }
        }
      }
      if (data.telecom) {
        for (const item of data.telecom) {
          if (item.system === 'phone' && item.use === 'work') {
            this.telefoneTrabalho = item.value;
          }
          if (item.system === 'phone' && item.use === 'temp') {
            this.telefone = item.value;
          }
          if (item.system === 'email') {
            this.email = item.value.toLowerCase();
          }
        }
      }
    }
  }

  public static fromDTO?(data) {
    const pacient = new Pacient();
    pacient.ativo = data.active;
    return pacient;
  }

  calcAge(dateString): string {
    const birthday = +new Date(dateString);
    // tslint:disable-next-line: no-bitwise
    const date = ~~((Date.now() - birthday) / (31557600000));
    return date.toString();
  }

  public toDTO?() {
    const dto: any = {};
    dto.active = this.ativo;

    return dto;
  }

}
